export default "__VITE_ASSET__85abc91c__"